import { withNamespaces } from "react-i18next";
import { Text, View } from "@react-pdf/renderer";
import styles from "../../Styles";

const CompanyInformation = ({ t, company, convertApiDate }) => {
  const org = (() => {
    try {
      return company?.organizationData
        ? JSON.parse(company.organizationData)
        : null;
    } catch {
      return null;
    }
  })();

  const orgAttr = org?.data?.attributes;

  const companyInformationRows = [
    {
      title: "Company Name",
      details: orgAttr?.name ?? company?.primaryName ?? "-",
    },
    {
      title: "Legal Form",
      details: orgAttr?.legalForm ?? "-",
    },
    {
      title: "Status",
      details: orgAttr?.status
        ? orgAttr.status.charAt(0).toUpperCase() + orgAttr.status.slice(1)
        : "-",
    },
    {
      title: "Registration Date",
      details: orgAttr?.registrationDate
        ? convertApiDate(orgAttr.registrationDate)
        : "-",
    },
    {
      title: "VAT Number",
      details: orgAttr?.vatNumber ?? "-",
    },
    {
      title: "Stock Ticker",
      details:
        Array.isArray(orgAttr?.stockTickers) && orgAttr.stockTickers.length
          ? orgAttr.stockTickers.join(", ")
          : "-",
    },
    {
      title: "Number of Employees",
      details:
        typeof orgAttr?.numberOfEmployees === "number"
          ? Intl.NumberFormat("en-US").format(orgAttr.numberOfEmployees)
          : "-",
    },
    {
      title: "Description",
      details: orgAttr?.description ?? "-",
    },
    {
      title: "Last Update",
      details: orgAttr?.lastUpdate?.date
        ? convertApiDate(orgAttr.lastUpdate.date)
        : "-",
    },
  ];

  return (
    <View style={styles.section}>
      <Text style={styles.sectionSeparator}>
        {`${t("1.")} ${t("Company Overview")}`}
      </Text>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Title")}
            </Text>
          </View>

          <View style={{ ...styles.tableColHeader, ...styles.borderRightNone }}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Details")}
            </Text>
          </View>
        </View>

        {companyInformationRows.map((d, i) => {
          const rowStyle = {
            ...styles.tableRow,
            ...(i === companyInformationRows?.length - 1
              ? styles.tableLastRow
              : {}),
          };

          return (
            <View style={rowStyle} key={i}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t(d.title)}</Text>
              </View>

              <View style={{ ...styles.tableCol, ...styles.borderRightNone }}>
                <Text style={styles.tableCell}>{d.details ?? "-"}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default withNamespaces()(CompanyInformation);
